<app-tool-scanner *ngIf="shouldRenderScanStatus()"></app-tool-scanner>

<app-form-error-list class="error-message" *ngIf="showErrors" [errorMap]="formControl.errors"></app-form-error-list>
<div *ngIf="showWarning"
     class="warning-message">{{ 'generic.scanner.warningMessage' | translate }}
</div>
<app-tree class="app-tree"
          [(selectedItems)]="selectedTools"
          [isScanListenerActive]="isScanListenerActive"
          [isMaterial]="isMaterial"
          [label]="labelText"
          [emptyMessage]="emptyMessage"
          [(items)]="items"
          [scanningEnabled]="scanEnabled"
          [selectDisabled]="inspectEnabled"
          [parameters]="parameters"
          [loading]="loading"
          [allExpanded]="allExpanded"
          (scan)="onScan($event)"
          (select)="onToolSelect($event)"
          (unselect)="onToolUnselect($event)"
          (selections)="onSelections($event)"
          (rowAlertClick)="onRowAlertClick($event)"
          (parameterIconClick)="onLeafIconClick($event)">
</app-tree>



